import { createContext, useContext } from 'react';

export type MobileWebConversationalDiscoveryExperimentContextType = {
  mobileWebConversationalDiscoveryEnabled: boolean;
  minimalTray: boolean;
  contextualTray: boolean;
};

export const MobileWebConversationalDiscoveryExperimentContext =
  createContext<MobileWebConversationalDiscoveryExperimentContextType>({
    mobileWebConversationalDiscoveryEnabled: false,
    minimalTray: false,
    contextualTray: false,
  });

export const useMobileWebConversationalDiscoveryExperiment = () => {
  return useContext(MobileWebConversationalDiscoveryExperimentContext);
};
